import { apiSlice } from "../apiSlice";

export interface PushNotificationTokenData {
    token: string;
    userType: string;
    customerId: string;    
}

interface AddMessageTokenResponse {
  success: boolean;
  message?: string;
}
const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN_PRODUCTION;
export const userService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    addMessageToken: builder.mutation<
      AddMessageTokenResponse,
      PushNotificationTokenData
    >({
      query: (data) => ({
        url: `https://customersitehttps-addmessagetoken-${API_BASE_DOMAIN}-uc.a.run.app`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: data,
      }),
    }),
  }),
});

export const {
  useAddMessageTokenMutation,
} = userService;
